import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";

export const SimpleModal = ({ title, children, handleClose }) => (
  <Modal
    show={true}
    onHide={handleClose}
    backdrop="static"
    keyboard={false}
    size="xl"
  >
    <Modal.Header closeButton>
      <Modal.Title className="d-flex">
        <span>{title}</span>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleClose}>
        <FormattedMessage id="component.common.modal.button.ok" />
      </Button>
    </Modal.Footer>
  </Modal>
);

SimpleModal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  handleClose: PropTypes.func.isRequired,
};
